module.exports = __webpack_public_path__ + "img/header-logo.54461fb6.svg";